import { useState, useEffect, useContext } from 'react';
import { Container, Row, Col, Card, Button,InputGroup,Form } from 'react-bootstrap';
import { useParams, useNavigate, Link } from 'react-router-dom';
import UserContext from '../UserContext';
import Swal from 'sweetalert2';
import '../App.css';

export default function ProductView(){
	//hook for global state
	const { user } = useContext(UserContext);

	//allows us to gain access to methods that will 
	//allows us to redirect a user to a different page after enrolling  a course
	const navigate = useNavigate(); //useHistory

	const [name, setName] = useState("");
	const [description, setDescription] = useState("");
	const [category, setCategory] = useState("");
	const [price, setPrice] = useState(0);
	const [quantity, setQuantity] = useState(1);
	const [totalAmount, setTotalAmount] = useState();




	//useParams is a hook that allows us to receive the courseId passed via URL
	const {productId} = useParams();
	

	const addQuantity = () =>{
		setQuantity(quantity + 1)
	}

	const subtractQuantity = () =>{
		if(quantity === 1){
			Swal.fire({
				title: 'Quantity' ,
				icon: 'info',
				text: 'The quantity cannot be less than 1'
			});
		} else{
		setQuantity(quantity - 1)
		}
	}

	const order = (productId) => {
		fetch(`${process.env.REACT_APP_API_URL}order/`,{
			method : 'POST',
			headers: {
				'Content-Type' : 'application/json',
				Authorization: `Bearer ${localStorage.getItem('token')}`
			},
			body: JSON.stringify({
				userId: user.id,
				productId: productId,
				productPrice: price,
				quantity: quantity,
				totalAmount: totalAmount


			})
			
		})
	
		.then(res => res.json())
		.then(data => {
			console.log(data);
			if (data === true) {
				Swal.fire({
					title: 'Successfully ordered!' ,
					icon: 'success',
					text: 'Thank you for ordering',
					showConfirmButton: false,
					timer: 1500
				});

					navigate("/product");


			} else {
				Swal.fire({
					title: 'Something went wrong',
					icon: 'error',
					text: 'Please try again later',
					showConfirmButton: false,
					timer: 1500
				})
			}
		})
	}

	useEffect(() => {
		console.log(productId)
		fetch(`${process.env.REACT_APP_API_URL}product/${productId}`)
		.then(res => res.json())
		.then(data => {
			console.log(data);

			setTotalAmount(data.price)
			setName(data.name);
			setDescription(data.description);
			setCategory(data.category);
			setPrice(data.price);
		});

	}, [productId]);
	



	useEffect(() => {
		setTotalAmount(quantity * price)

	
		}, [quantity, price]);


	return(
// put Row on view
		<Container className="  mt-5"  >
		 <Row  >
		<Col xs={12} md={8} >
            <Card className="cardCourses   p-3" >
                <Card.Body >
                   
                    <Card.Header className="text-center card-header">{name}</Card.Header>
                    <Card.Subtitle className=" text-center mt-4">Description:</Card.Subtitle>
                    <Card.Text className=" text-center">{description}</Card.Text>
                    <Card.Subtitle className=" text-center">Price:</Card.Subtitle>
                    <Card.Text className=" text-center">{price}</Card.Text>
					<Card.Subtitle className=" text-center" >Category:</Card.Subtitle>
                    <Card.Text className=" text-center">{category}</Card.Text>
					{ user.id !== null ?
					 <>
						<Card.Subtitle className=" text-center" >SubTotal:</Card.Subtitle>
                    <Card.Text className=" text-center" >{totalAmount}</Card.Text>
					
					<Card.Subtitle className=" text-center mb-1" >Quantity:</Card.Subtitle>
					<div className='d-flex flex-row justify-content-center'>
					<div className="quantity-contain " >
					<InputGroup  >
						<Button variant='dark' onClick={() => subtractQuantity(productId)}>-</Button>
							<Form.Control
								className='text-center bkg-light'
								value={quantity}
								onChange={(e) => setQuantity(e.target.value)
								}
							/>
						<Button variant='dark' onClick={() => addQuantity(productId)} >+</Button>
					</InputGroup>
					</div>
					</div>

				{/* 	<Container className="d-flex flex-row justify-content-center">
					<Button className='bkg-light' onClick={() => subtractQuantity(productId)}> - </Button>
					<Card.Text className="border text-center" style={{width:"30px"}}>{quantity}</Card.Text>
					<Button className='info' onClick={() => addQuantity(productId)} > + </Button>
					</Container> */}



					
					</>
						:
						<Card.Subtitle className=" text-center" >Login To Order</Card.Subtitle>

					}
                  

                   
                </Card.Body>
				{ user.id !== null ?
						<Button className=" d-flex flex-column justify-content-end align-items-center  btn btn-info ml-3" onClick={() => order(productId)}>Order</Button>
						 :
						<Link className = " d-flex flex-column justify-content-end align-items-center  btn btn-danger mt-4" to="/login">Log In </Link>
					}
            </Card>
        </Col>
		</Row>
		</Container>
	)
}